import { useEffect, useRef } from "react";
import { UseFormReturn } from "react-hook-form";
import { CreateContractorVisitFormType } from "../types";

export const useDependentFieldsReset = (
  form: UseFormReturn<CreateContractorVisitFormType>,
  projectId?: string,
  storeId?: string,
  projectRoleId?: string,
  date?: string,
) => {
  const previous = useRef<{
    projectId?: string;
    storeId?: string;
    projectRoleId?: string;
    date?: string;
  }>({
    projectId: undefined,
    storeId: undefined,
    projectRoleId: undefined,
    date: undefined,
  });

  useEffect(() => {
    const current = {
      projectId,
      storeId,
      projectRoleId,
      date,
    };

    const prev = previous.current;

    const projectChanged =
      prev.projectId !== undefined && prev.projectId !== current.projectId;

    const storeChanged =
      prev.storeId !== undefined && prev.storeId !== current.storeId;

    const roleChanged =
      prev.projectRoleId !== undefined &&
      prev.projectRoleId !== current.projectRoleId;

    const sameStoreAndRole =
      prev.storeId === current.storeId &&
      prev.projectRoleId === current.projectRoleId;

    const storeOrRoleChanged = storeChanged || roleChanged;

    const dateChanged =
      prev.date !== undefined && prev.date !== current.date && sameStoreAndRole;

    if (projectChanged) {
      form.resetField("store_id");
      form.resetField("project_role_id");
      form.resetField("settlement_type");
      form.resetField("contractor_id");
    } else if (storeOrRoleChanged) {
      form.resetField("settlement_type");
      form.resetField("contractor_id");
    } else if (dateChanged) {
      form.resetField("contractor_id");
    }

    previous.current = current;
  }, [projectId, storeId, projectRoleId, date, form]);
};
